"use client";

import { useEffect, useContext } from "react";
import { AuthContext } from "@finbackoffice/site-core";
import { ConfigContextV2 } from "contexts";
import { UIStateContext } from "contexts";
import { NotFound } from "components/base/not-found/NotFound";

const Error404Screen = ({ token }: { token?: string }) => {
    const { loadSiteConfig } = useContext(ConfigContextV2);
    const { setToken } = useContext(AuthContext);
    const { setIsNotFoundPage } = useContext(UIStateContext);

    useEffect(() => {
        setIsNotFoundPage(true);
        if (token) {
            setToken(token);
        }

        void loadSiteConfig();

        return () => {
            setIsNotFoundPage(false);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <NotFound statusCode={404} />;
};

export default Error404Screen;
